module.exports = __webpack_public_path__ + "static/img/htb_shipping_pic.17a6023.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/home/htb_shipping_pic.png
// module id = 2HzR
// module chunks = 31